module.exports = __webpack_public_path__ + "img/hylappios156.e0c06445.png";